<form [formGroup]="form">
    <div id="paymentPart" class="row">
        <div class="col-md-12 col-sm-12">
            <app-payment-method-form [selectedSubscription]="subscription" [selectedOptions]="equipmentOptions"
                [showDiscountCode]="false" [showShoppingCart]="true" (paymentDataResult)="getPaymentData($event)"
                (applyDiscountCode)="getDiscountData($event)">
            </app-payment-method-form>
        </div>
        <div class="col-md-12 col-sm-12">
            <div class="checkbox-error"
                [class.show]="touched && (!currentPaymentData || !currentPaymentData.validatePaymentData())">
                {{'COMMON.INVALID_FORM' | translate}}
            </div>
        </div>
    </div>
    <div class=" row">
        <div class="col-md-12 col-sm-12 top15">
            <mat-form-field class="col-md-12 col-sm-12 col-xs-12">
                <mat-label>{{'REGISTRATION.STEP.PAYMENT.ADDITIONAL_INFO' | translate}}</mat-label>
                <textarea matInput formControlName="additionalInfo" name="additionalInfo"></textarea>
            </mat-form-field>
        </div>

    </div>
    <div class="row" formGroupName="checkBoxes">
        <div class="row">
            <!-- Acceptation of all general conditions -->
            <mat-checkbox class="col-md-12 col-sm-12" formControlName="generalConditions" id="generalConditions">
                {{'REGISTRATION.STEP.PAYMENT.CHECKBOX.GENERAL_CONDITIONS' | translate}}
            </mat-checkbox>
            <!-- Will be mandatory to validate mandate on SEPA payment -->
            <mat-checkbox class="col-md-12 col-sm-12" formControlName="debit" id="debit">
                {{'REGISTRATION.STEP.PAYMENT.CHECKBOX.DEBIT' | translate}}
            </mat-checkbox>
            <!-- Already agreed in general conditions but must be accepted by the user anyway (mandatory for RGPD compliance) -->
            <mat-checkbox class="col-md-12 col-sm-12" formControlName="consent" id="consent">
                {{'REGISTRATION.STEP.PAYMENT.CHECKBOX.CONSENT' | translate}}
            </mat-checkbox>
            <!-- mandatory for the home support -->
            <mat-checkbox class="col-md-12 col-sm-12" formControlName="taxCredit" id="taxCredit">
                {{'REGISTRATION.STEP.PAYMENT.CHECKBOX.TAX_CREDIT' | translate}}
            </mat-checkbox>
        </div>
        <div name="payment-checkbox-error" class="checkbox-error"
            [class.show]="(form.get('checkBoxes').touched && !isValid('checkBoxes')) || form.get('checkBoxes')?.get('taxCredit').invalid">
            <ng-container *ngIf="form.get('checkBoxes')?.get('taxCredit').invalid;else standard">
                {{'REGISTRATION.STEP.PAYMENT.CHECKBOX.TAX_CREDIT_NOTE' | translate}}
                <a target="_BLANK"
                    href="https://www.co-assist.fr/contact/">{{'REGISTRATION.STEP.PAYMENT.CHECKBOX.CONTACT' |
                    translate}}</a>
            </ng-container>
            <ng-template #standard>
                {{'REGISTRATION.STEP.PAYMENT.CHECKBOX.CONDITIONS_MANDATORY' | translate}}
            </ng-template>

        </div>
    </div>
    <div class="row">
        <div class="col-md-12 controls-button">
            <button mat-stroked-button color="primary" class="pull-left" style="margin-right: 3%" (click)="previous()">
                {{'COMMON.BACK' | translate}}
            </button>
            <button mat-raised-button name="goNext7" (click)="submitPayment()"
                class="mat-raised-button mat-primary pull-right">
                {{'REGISTRATION.STEP.PAYMENT.CONFIRM_ORDER' | translate}}
            </button>
        </div>
    </div>
</form>